module.exports = __webpack_public_path__ + "img/scroll_h.5942b664.svg";